/**
 * CreateButton — ЕДИНАЯ кнопка «Создать» генерационных баров.
 *
 * Используется и в классическом баре (GenerateInputBar), и в tool-режиме
 * (GenerateToolMode): один компонент с параметрами вместо двух разных
 * <button> (раньше вид расходился: .gm__send vs .gtm__gen). Логика запроса
 * НЕ здесь — кнопка лишь дергает переданный onClick (общий
 * gen.handleGenerate из GenerateContext: валидация → запрос → поллинг).
 *
 * Параметры:
 *   cost  — цена на кнопке («Создать · 45» и иконка токена); не передан — просто «Создать».
 *   loading — спиннер вместо контента (и класс --loading).
 */
import { useTranslation } from 'react-i18next'
import { Icon } from '../../../../public/icons/Icon.tsx'
import TokenPrice from '../../../components/TokenPrice'

interface Props {
	onClick: () => void
	disabled?: boolean
	loading?: boolean
	/** Цена на кнопке («Создать · 45» и иконка токена). undefined/null — без цены. */
	cost?: number | null
	/** Свой текст вместо «Создать» (этапы пайплайна: «Создать фото» и т.п.). */
	label?: string
	className?: string
	title?: string
}

export default function CreateButton({
	onClick,
	disabled,
	loading,
	cost,
	label,
	className = '',
	title,
}: Props) {
	const { t } = useTranslation()
	return (
		<button
			type="button"
			className={`gm__send${loading ? ' gm__send--loading' : ''}${
				cost != null ? ' gm__send--cost' : ''
			}${className ? ` ${className}` : ''}`}
			onClick={onClick}
			disabled={disabled}
			aria-label={loading ? t('generate.input.generatingLabel') : t('generate.input.generateLabel')}
			title={title}
		>
			{loading ? (
				<Icon id="gen-spin" size={18} className="spin" />
			) : (
				<>
					<Icon id="gen-send" size={16} />
					{/* Цена — число и иконка токена (общий TokenPrice, как у цен по всему сайту;
					    владелец, 02.10: «в кнопку нужно добавить иконку токенов»). Без title:
					    подсказка кнопки (например «Добавьте фото…») не должна подменяться. */}
					<span className="gm__send-label">
						{label || t('generate.input.create')}
						{cost != null && <>{' · '}<TokenPrice value={cost} ariaLabel={false} /></>}
					</span>
					{/* Мобила: полная подпись не влезает и скрыта CSS, но ЦЕНУ юзер
					    обязан видеть до нажатия — на узком экране её больше негде
					    показать (жалоба владельца 2026-07-25). Оставляем только
					    цену рядом со стрелкой. */}
					{cost != null && <span className="gm__send-cost"><TokenPrice value={cost} ariaLabel={false} /></span>}
				</>
			)}
		</button>
	)
}
